import React from 'react';
import { Provider } from 'react-redux';
import store from './store';

interface ReduxProviderInterface {
  children: React.ReactNode;
  store?: typeof store;
}

function ReduxProvider({
  children,
  store: customStore = store,
}: ReduxProviderInterface): JSX.Element {
  return <Provider store={customStore}>{children}</Provider>;
}

export default ReduxProvider;
